import { initShopeepayReporter } from '@shopeepay/reporter'

// shopeepay-ph has no HTTP client (static site, no axios/fetch usage),
// so the axios instrumentation step is omitted.
initShopeepayReporter({ region: 'ph', project: 'shopeepay-ph' })
